import { Phone, CalendarHeart } from "lucide-react";
import { DOCTOR } from "@/lib/data";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden">
      {/* Decorative botanical layer */}
      <div aria-hidden className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-sage/15 blur-3xl" />
      <div aria-hidden className="absolute top-1/2 -right-32 w-[480px] h-[480px] rounded-full bg-terracotta/15 blur-3xl" />

      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center relative">
        <div className="lg:col-span-7 anim-fade-up">
          <p className="label-eyebrow" data-testid="hero-eyebrow">Gynaecology · Obstetrics · Women's Wellness</p>
          <h1 className="font-serif font-medium text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05] text-forest mt-6">
            Empowering women's health
            <span className="block italic text-terracotta">at every stage of life.</span>
          </h1>
          <p className="mt-7 max-w-xl text-lg md:text-xl leading-relaxed text-forest/75">
            Consult <span className="text-forest font-medium">{DOCTOR.name}</span> — {DOCTOR.title}, practising with care and dignity in Birpara, Alipurduar.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a data-testid="hero-book-btn" href="#book" className="btn-primary">
              <CalendarHeart className="w-5 h-5" strokeWidth={1.5} /> Book Consultation
            </a>
            <a data-testid="hero-call-btn" href={`tel:${DOCTOR.phones[0].replace(/\s/g, "")}`} className="btn-outline">
              <Phone className="w-5 h-5" strokeWidth={1.5} /> {DOCTOR.phones[0]}
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            <div>
              <div className="font-serif text-4xl text-forest">10+</div>
              <div className="text-xs tracking-[0.2em] uppercase text-sage mt-1">Years of Care</div>
            </div>
            <div>
              <div className="font-serif text-4xl text-forest">2</div>
              <div className="text-xs tracking-[0.2em] uppercase text-sage mt-1">Clinic Locations</div>
            </div>
            <div>
              <div className="font-serif text-4xl text-forest">4</div>
              <div className="text-xs tracking-[0.2em] uppercase text-sage mt-1">Languages Spoken</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative anim-fade-up" style={{ animationDelay: "120ms" }}>
          <div className="relative w-full aspect-[4/5] max-w-md mx-auto">
            <div aria-hidden className="absolute inset-0 rounded-t-[240px] rounded-b-[40px] bg-sand" />
            <img
              data-testid="hero-portrait"
              src={DOCTOR.portrait}
              alt={DOCTOR.name}
              className="absolute inset-2 rounded-t-[230px] rounded-b-[36px] object-cover w-[calc(100%-16px)] h-[calc(100%-16px)]"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-lg border border-sand px-5 py-4">
              <p className="text-xs tracking-[0.2em] uppercase text-sage">Now Consulting</p>
              <p className="font-serif text-xl text-forest mt-1">12 PM – 4 PM</p>
              <p className="text-xs text-forest/60">Everyday</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
